export enum BasketCompleteStatus {
  NONE = 'None',
  SUCCESS = 'Success',
  ERROR = 'Error',
  PENDING_PAYMENT = 'PendingPayment',
}
